import { Controller } from "@hotwired/stimulus";

import debounce from "debounce";

import Cookies from "js-cookie";

// Connects to data-controller="native"
export default class extends Controller {
  static targets = ["footer", "token", "haptic", "message"];
  static values = { refresh: { type: Boolean, default: false } };

  send(message) {
    if (window.ReactNativeWebView) window.ReactNativeWebView.postMessage(JSON.stringify(message));
  }

  modal = false;
  replace = false;

  tokenTargetConnected() {
    setTimeout(() => {
      this.send({
        kind: "token",
        value: this.tokenTarget.dataset.value,
      });
    }, this.tokenTarget.dataset.timeout);
  }

  messageTargetConnected(message) {
    setTimeout(() => {
      this.send({
        kind: message.dataset.name,
        value: message.dataset.value,
      });
    }, message.dataset.timeout);
  }


  hapticTargetConnected() {
    this.haptic({});
  }

  disconnect() {
    if (this.cookieInterval) clearInterval(this.cookieInterval);
  }

  cookies() {
    this.cookieInterval = setInterval(() => {
      let cookie = Cookies.get('bridge');

      if (cookie) {
        let cookieParts = cookie.split('#');
        let cookieKind = cookieParts[0];
        let cookieValue = cookieParts[1];

        switch (cookieKind) {
          case "refresh":
            let bridgeController = document.body.dataset.bridgeController;

            if (bridgeController == cookieValue) {
              Cookies.remove('bridge')
              this.refresh()
            }
            break;
        }

      }
    }, 5000);
  }

  connect() {
    if (document.body.dataset.bridgeEvents) this.cookies();

    document.querySelectorAll('a[href^="http"]').forEach((link) => {
      link.addEventListener("click", e => {
        let target = e.target;
        if (target.tagName != 'A') target = target.closest('a');

        if (target.href.indexOf('movesgreen') != -1) return;

        e.preventDefault();

        this.send({
          kind: "browser",
          value: target.href,
        });
      });
    });

    window.shouldPreserveScroll = true;

    if (this.refreshValue) {
      this.send({
        kind: "settings",
        refresh: this.refreshValue,
      });
    }

    //this.click = debounce(this.click.bind(this), 100);

    document.addEventListener("turbo:before-visit", this.visit.bind(this));
    document.addEventListener("turbo:load", this.load.bind(this));
    document.addEventListener("turbo:click", this.click.bind(this));
    document.addEventListener("turbo:submit-start", this.submit.bind(this));
    document.addEventListener("turbo:submit-end", this.submitEnd.bind(this));

    window.addEventListener("message", (nativeEvent) => {
      let data = JSON.parse(nativeEvent.data);

      let kind = data.kind;

      if (!kind) return;

      switch (kind) {
        case "refresh":
        case "focus":
          if (!document.body.hasAttribute('data-refresh')) return;

          this.refresh()
          break;
        case "blur":
          break;
        case "pushToken":
          break;
      }
    });

    if (this.hasFooterTarget && window.visualViewport) {
      window.visualViewport.addEventListener(
        "resize",
        this.fixPosition.bind(this)
      );
      this.fixPosition(); // Make sure we call it once before resizing too
    }
  }

  refresh() {
    this.scrollY = window.scrollY;
    Turbo.visit(window.location.href, { action: "replace" });
  }

  load() {
    if (!this.scrollY) return;

    window.scrollTo(0, this.scrollY);
    this.scrollY = null;
  }

  click(e) {
    this.modal = e.target?.getAttribute("data-modal") ? true : false;
    this.replace = e.target?.getAttribute("data-turbo-action") == "replace";
    this.title = e.target?.getAttribute("data-title");
    this.form = false;
    this.skip = e.target?.getAttribute('data-bridge')

    if (!this.skip && e.target?.getAttribute('data-refresh')) {
      document.body.dataset.refresh = true
    }
  }

  submit(e) {
    this.form = true;
  }

  submitEnd(e) {
    try {
      e.detail.fetchResponse.response.json().then((result) => {
        setTimeout(() => {
          this.send(result);
        });
      });
    } catch (e) { }
  }

  visit(e) {
    if (this.form) {
      this.form = false;
      return;
    }

    if (this.skip) {
      this.skip = false;
      return;
    }

    if (e.detail.url == window.location.href) return;

    e.preventDefault();

    if (!window.ReactNativeWebView) {
      console.log(e);
      return;
    }

    this.send({
      kind: "visit",
      url: e.detail.url,
      modal: this.modal,
      replace: this.replace,
      navigation: {
        options: {
          headerShown: true,
          headerTitle: this.title,
        },
      },
    });

    this.modal = false;
    this.replace = false;
    this.title = null;
  }

  fixPosition() {
    this.footerTarget.style.top = `${window.visualViewport.height}px`;
  }

  sheet(e) {
    let options = {}

    let { sheetSnap } = e.currentTarget.dataset;

    if (e.currentTarget.tagName == 'A' && e.currentTarget.getAttribute('href') != '') {
      options.url = e.currentTarget.href + '?native[sheet]=true';

      if (!sheetSnap) sheetSnap = 500;
    } else {
      const { sheetTitle, sheetDescription, sheetSnap } = e.currentTarget.dataset;

      options.html = `<h3 style="margin: 0">${sheetTitle}</h3><p>${sheetDescription}</p>`;
    }

    if (sheetSnap) options.bottomSheet = { snapPoints: [parseInt(sheetSnap), parseInt(sheetSnap)] }

    if (e.currentTarget.getAttribute('data-refresh')) {
      //document.body.dataset.refresh = true

      //alert('hi')
    }

    e.preventDefault();
    this.send({
      kind: "sheet",
      sheet: options,
    });
  }

  browser(e) {
    e.preventDefault();
    this.send({
      kind: "browser",
      value: e.target.href,
    });
  }

  logout(e) {
    e.preventDefault();
    this.send({
      kind: "logout",
    });
  }

  tab(e) {
    e.preventDefault();
    this.send({
      kind: "tab",
      name: e.currentTarget.dataset.name,
      params: { refresh: 1, url: "https://www.webics.nl", key: "SSS" },
    });
    setTimeout(() => {
      this.send({
        kind: "browser",
        value: "https://www.webics.nl",
      });
    }, 1000);
  }

  haptic(e) {
    this.send({
      kind: "haptic"
    });
  }

  hello(e) {
    e.preventDefault();
    this.send({
      kind: "alert",
      title: "Hello from Rails!",
      description: "This is a test alert!",
    });
  }
}
